// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"443":"ab63d6e6","504":"6917b893","559":"ab63d6e6","628":"0ad29220","945":"ab63d6e6"}[chunkId] + ".chunk.css";
};